/** Narrows an unvalidated value to a string enum's member union. Numeric enums are excluded: their reverse mappings put member NAMES in `Object.values`. */
export const isEnumValue = <TEnum extends Record<string, string>>(enumObject: TEnum, value: unknown): value is TEnum[keyof TEnum] => {
  const members: readonly unknown[] = Object.values(enumObject);
  return members.includes(value);
};
